import { Action, createReducer, on } from '@ngrx/store';
import { Params } from '@angular/router';
import { RoutePath } from '../../shared/models/route-path.enum';
import { updateRouteAction } from './route.actions';

export interface RouteState {
    page: RoutePath;
    id?: string;
    feature?: string;
    hidePanels?: boolean;
    queryParams?: Params;
}

const initialState: RouteState = {
    page: RoutePath.SITES,
};

const reducer = createReducer(
    initialState,
    on(updateRouteAction, (state, { page, id, feature, hidePanels, queryParams, start }) => {
        if (start) {
            return state;
        }

        return {
            ...state,
            page,
            id,
            feature,
            hidePanels,
            queryParams,
        };
    }),
);

export function routeReducer(
    state: RouteState | undefined,
    action: Action,
): RouteState {
    return reducer(state, action);
}
